import React from 'react'
import translate from 'core/translate'
import { cn } from 'ethcss'
import styles from './deviceSettings__lowBatteryWarning.jcss'
import { Typography } from 'atoms/Typography'
import { SwitchButton } from '../../../atoms/SwitchButton'

const DeviceSettingsSystemNotifications = (p_: {
    enabled: boolean
    value: boolean
    onChange: (value: any, field: string) => void
    className: string | object
}) => {
    if (!p_.enabled) {
        return null
    }

    return (
        <div className={cn(p_.className)}>
            <div className={styles.switchWrapper}>
                <SwitchButton
                    checked={p_.value}
                    onChange={() => {
                        p_.onChange(!p_.value, 'batteryWarningIconDisplay')
                    }}
                    className={`test-settings-toggle_${p_.value ? 'enabled' : 'disabled'}`}
                />
                <div className={cn(styles.switchCaption)}>
                    <Typography type="title">{translate('batteryWarningIconDisplay')}</Typography>
                </div>
            </div>
            <div className={styles.hint}>{translate('batteryWarningIconDisplayHint')}</div>
        </div>
    )
}

export default React.memo(DeviceSettingsSystemNotifications)
